/**
 * メガメニューの開閉制御（ホバー＋キーボード対応）
 * ヘッダー全体を監視し、その外にマウスが出たときだけ閉じる
 * 複数のメガメニュートリガーに対応
 */
const megaMenu = () => {
  const triggers = document.querySelectorAll('.js-mega-menu__trigger');
  if (!triggers.length) return;

  const header = document.getElementById('js-header');
  if (!header) return;

  const overlay = document.querySelector('.m-mega-menu__overlay');
  if (!overlay) return;

  let closeTimer = null;
  let activeMenu = null;
  let activeTrigger = null;

  const openMenu = (trigger, menu) => {
    clearTimeout(closeTimer);

    // 別のメニューが開いていたら即閉じる
    if (activeMenu && activeMenu !== menu) {
      activeMenu.setAttribute('aria-hidden', 'true');
      activeMenu.classList.remove('is-open');
      activeTrigger.setAttribute('aria-expanded', 'false');
    }

    trigger.setAttribute('aria-expanded', 'true');
    menu.removeAttribute('aria-hidden');
    menu.classList.add('is-open');
    overlay.classList.add('is-open');
    activeMenu = menu;
    activeTrigger = trigger;
  };

  const closeActive = () => {
    if (!activeMenu) return;
    activeTrigger.setAttribute('aria-expanded', 'false');
    activeMenu.setAttribute('aria-hidden', 'true');
    activeMenu.classList.remove('is-open');
    overlay.classList.remove('is-open');
    activeMenu = null;
    activeTrigger = null;
  };

  const scheduleClose = () => {
    closeTimer = setTimeout(closeActive, 100);
  };

  triggers.forEach((trigger) => {
    const menuId = trigger.getAttribute('aria-controls');
    const menu = document.getElementById(menuId);
    if (!menu) return;

    // ホバーで開く
    trigger.addEventListener('mouseenter', () => openMenu(trigger, menu));

    // メガメニュー内に入ったらタイマーキャンセル
    menu.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    menu.addEventListener('mouseleave', scheduleClose);

    // クリック（キーボード兼用）
    trigger.addEventListener('click', () => {
      if (menu.classList.contains('is-open')) {
        closeActive();
      } else {
        openMenu(trigger, menu);
      }
    });
  });

  // ヘッダー全体から出たら閉じる
  header.addEventListener('mouseleave', scheduleClose);

  // トリガー以外のナビリンクに入ったら閉じる
  header.querySelectorAll('.m-header__link:not(.js-mega-menu__trigger)').forEach((link) => {
    link.addEventListener('mouseenter', scheduleClose);
  });

  // Escapeキーで閉じる
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeMenu) {
      const focusTrigger = activeTrigger;
      closeActive();
      focusTrigger.focus();
    }
  });

  // オーバーレイクリックで閉じる
  overlay.addEventListener('click', closeActive);
};

export { megaMenu };
